<template>
  <div class="app-inner">
    <TableList
    :loading="loading"
    :data="tableData"
    :page="page"
    :page-size="pageSize"
    :total="totalCount"
    :columnDefs="columnDefs"
    @pageChange="pageChange"
    >
    <!-- :selectable="selectable"
      @selection-change="handleSelection" -->
      <!-- <template #selection/>
      <template #index/> -->
      <template #operate={row}>
        <el-button @click="edit(row)" type="text" size="small">编辑</el-button>
      </template>
    </TableList>
    <!-- 编辑 -->
    <el-dialog
    title="流程配置"
    class="edit-dialog"
    :visible.sync="showEdit"
    :before-close="close"
    center>
      <el-form
      ref="editForm"
      class="editForm"
      :model="editForm"
      label-width="20%"
      >
        <el-form-item label="流程分类" prop="flowName">
          <el-input v-model="editForm.flowName" disabled/>
        </el-form-item>
        <el-form-item
        v-for="(item, index) in editForm.reviewerList"
        :key="`reviewerList${index}`"
        :label="index === 0 ? editForm.flowName.indexOf('提醒') > 0 ? '提醒人' : '审核人' : ''"
        :prop="'reviewerList.' + index"
        :rules="{
          required: true, message: editForm.flowName.indexOf('提醒') > 0 ? '请选择提醒人' : '请选择审核人', trigger: 'change'
        }">
          <el-select v-model="editForm.reviewerList[index]" placeholder="请选择" clearable>
            <el-option
              v-for="item in staffList"
              :key="item.id"
              :value="`${item.userName}`"
              :label="`${item.chineseName || '暂无'} - ${item.workno || '暂无'}`"
            >
            {{item.chineseName || '暂无'}} - {{item.workno || '暂无'}}
            </el-option>
          </el-select>
          <div class="operate">
            <i class="el-icon-circle-plus-outline" @click="addApprovers"/>
            <i class="el-icon-remove-outline" @click="deleteApprovers(index)" v-if="index > 0"/>
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="editEventForm()">提 交</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import TableList from '@/components/TableList.vue'
import { query, update } from '@/api/baseFlowConfig'
import { queryUserInfo } from '@/api/basicInfo'
export default {
  data () {
    return {
      editForm: {
        flowName: '',
        id: '',
        reviewerList: []
      },
      loading: false,
      showEdit: false,
      tableData: [],
      pageSize: 10,
      totalCount: 0,
      page: 1,
      columnDefs: [
        { label: '流程分类', prop: 'flowName' },
        { label: '操作', prop: 'operate' }
      ],
      staffList: [],
      allowType: [ '证件使用审核流程', '请假审核流程', '加班审核流程', '用车审核流程', '用章审核流程', '报销审核流程', '考勤审核流程' ]
    }
  },
  components: {
    TableList
  },
  methods: {
    edit (row) {
      this.editForm = {
        ...row,
        reviewerList: (row?.reviewerList || '').split(',')
      }
      // if (this.allowType.includes(row.flowName)) {
      //   this.editForm.reviewerList.unshift('所属部门负责人审核');
      // }
      this.showEdit = true
    },
    close () {
      this.showEdit = false
    },
    getStaffList () {
      queryUserInfo({
        enableStatus: '1'
      }).then(res => {
        const { code, result } = res
        if (code !== 0) return
        this.staffList = result.records
      })
    },
    getData () {
      this.loading = true
      query({
        pageSize: this.pageSize,
        pageNum: this.page
      }).then(res => {
        const { result, code } = res
        this.loading = false
        if (code !== 0) return
        this.tableData = result.records.filter(v => !this.allowType.includes(v.flowName))
        this.totalCount = this.tableData.length
      })
    },
    pageChange (page) {
      this.page = page
      this.getData()
    },
    editEventForm () {
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          // if (this.allowType.includes(this.editForm.flowName)) {
          //     this.editForm.reviewerList.shift()
          // }
          update({
            ...this.editForm,
            reviewerList: this.editForm.reviewerList.join(',')
          }).then(res => {
            const { code } = res
            if (code !== 0) return
            this.$message.success('编辑流程成功')
            this.showEdit = false
            this.getData()
          })
        }
      })
    },
    addApprovers () {
      this.editForm.reviewerList.push('')
    },
    deleteApprovers (index) {
      this.editForm.reviewerList.splice(index, 1)
    }
  },
  mounted () {
    this.getData()
    this.getStaffList()
  }
}
</script>

<style lang="scss" scoped>
/deep/ .el-dialog{
  min-width: 500px;
  width: 30%;
}
.edit-dialog {
  .editForm {
    max-height: 50vh;
    overflow-x: scroll;
    &::-webkit-scrollbar {
      display: none;
    }
  }
  .operate {
    display: inline-block;
    font-size: 24px;
    i {
      margin: 0 5px;
    }
  }
}
</style>
